// ABOUTME: REST hook that asks the server whether a finalized configuration chains into a second product.
// ABOUTME: Returns the next product id and pre-seed selections, or null when no chain applies.

import { TUserAssignment } from '@coolshop/cool-configurator';
import { useCallback } from 'react';

interface ApiResponse<T> {
    success: boolean;
    data?: T;
    error?: string;
}

export interface ChainResolution {
    nextProductId: string;
    initialUserAssignments: TUserAssignment[];
}

/**
 * Hook that resolves configuration chaining for the offer configurator flow. Returns null when
 * chaining is disabled in settings or the finalized configuration does not select a second product.
 */
export function useResolveChain() {
    return useCallback(async (configurationJson: string): Promise<ChainResolution | null> => {
        const response = await fetch('/api/cpq/offers/configurator/resolve-chain', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ configurationJson }),
        });
        const json: ApiResponse<ChainResolution | null> = await response.json();
        if (!json.success) {
            throw new Error(json.error ?? 'Failed to resolve configuration chain');
        }
        return json.data ?? null;
    }, []);
}
